module.exports = __webpack_public_path__ + "img/icono_hospital.b99933b4.svg";